<template>
    <div>
        <bs-card class="card-info" :icon="icon" :label="$t('labels.' + camelToSnake($options.name))">
            <template v-slot:header>
                <bs-button class="btn-sm btn-info" @click="create">{{ $t('labels.create_' + camelToSnake(singular($options.name))) }}</bs-button>
            </template>
            <bs-table v-bind="{dataLength, loading}" :cols="2">
                <template v-slot:thead>
                    <tr>
                        <th scope="col">{{ $t('labels.name') }}</th>
                        <th scope="col"></th>
                    </tr>
                </template>
                <tr v-for="r in resources.data" :key="r.id">
                    <td>{{ r.name }}</td>
                    <td class="t2">
                        <bs-action :icon="['fal', 'pencil']" class="btn-info" @click="update(r)"></bs-action>
                        <bs-action :icon="['fal', 'trash']" class="btn-danger" @click="destroy(r)"></bs-action>
                    </td>
                </tr>
                <template v-slot:tfoot>
                    <pagination :data="resources" :state="resourceState" @pushPage="index"></pagination>
                </template>
            </bs-table>
        </bs-card>
        <bs-modal :name="'create-' + $options.name" :label="$t('labels.create_' + camelToSnake(singular($options.name)))">
            <bs-form :submit="$t('labels.submit')" @submit="submit">
                <template v-slot:default="slotProps">
                    <input-field :name="'name'" :label="$t('labels.name')" v-model="resource.name" :error="slotProps.error"></input-field>
                    <checkbox-field :label="'Permissions'" :options="permissions" v-model="resource.permissions"></checkbox-field>
                </template>
            </bs-form>
        </bs-modal>
        <bs-modal :name="'destroy-' + $options.name" :label="$t('labels.destroy_' + camelToSnake(singular($options.name)))">
            <bs-form :destroy="$t('labels.destroy')" @submit="destruction">
                {{ $t('messages.delete', { resource: camelToSpace(singular($options.name)) }) }}
            </bs-form>
        </bs-modal>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { resourceControl } from '../../mixins/resourceControl'

export default {
  name: 'Roles',
  mixins: [resourceControl],
  data () {
    return {
      icon: ['fal', 'books'],
      resource: {
        name: '',
        permissions: []
      },
      permissions: {
        task_records: {
          name: this.$t('permits.task_records'),
          children: {
            create_task: this.$t('permits.create_task'),
            view_task_comments: this.$t('permits.view_task_comments'),
            update_task: this.$t('permits.update_task'),
            delete_task: this.$t('permits.delete_task')
          }
        },
        budget_overview: {
          name: this.$t('permits.budget_overview'),
          children: {
            order_units: this.$t('permits.order_units')
          }
        },
        retrieve_clients: {
          name: this.$t('permits.retrieve_clients'),
          children: {
            client_comments: this.$t('permits.client_comments'),
            client_settings: this.$t('permits.client_settings'),
            client_snapshot: this.$t('permits.client_snapshot'),
            client_overview: this.$t('permits.client_overview'),
            target_keywords: this.$t('permits.target_keywords'),
            visitor_referrers: this.$t('permits.visitor_referrers'),
            approved_units: this.$t('permits.approved_units'),
            visitor_keywords: this.$t('permits.visitor_keywords'),
            update_client: this.$t('permits.update_client')
          }
        },
        settings: {
          name: this.$t('permits.settings'),
          children: {
            users: this.$t('permits.users'),
            roles: this.$t('permits.roles'),
            unit_types: this.$t('permits.unit_types'),
            seom_account: this.$t('permits.seom_account')
          }
        }
      }
    }
  },
  computed: {
    ...mapState({
      resources: state => state.roles,
      resourceState: state => state.rolesState,
      submitting: state => state.submitting
    })
  }
}
</script>
